import React from 'react';
import {connect} from 'react-redux';
import {Checkbox, Grid} from 'semantic-ui-react';
import {saveResourceFieldAction} from "../../resources/actions";

const SponsoredWinnerAuditing = props => (
  <Grid columns={2} className='sponsored-winner-auditing'>
    <Grid.Row>
      <Grid.Column width={8}>
        <Checkbox label='Sent'
                  checked={props.w9AffidavitSent}
                  onChange={props.checkSent} />
      </Grid.Column>
      <Grid.Column width={8}>
        <Checkbox label='Received'
                  checked={props.w9AffidavitReceived}
                  onChange={props.checkReceived} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

const mapState = (state, props) => {
    return {

    }
};

const mapDispatch = (dispatch, props) => {
    return {
        checkSent: () => dispatch(saveResourceFieldAction(
            props.resourceId,
            props.resourceId,
            [],
            ["w9AffidavitSent"],
            "w9AffidavitSent",
            true,
            [props.resourceId]
        )),
        checkReceived: () => dispatch(saveResourceFieldAction(
            props.resourceId,
            props.resourceId,
            [],
            ["w9AffidavitReceived"],
            "w9AffidavitReceived",
            true,
            [props.resourceId]
        ))
    }
};

export default connect(mapState, mapDispatch)(SponsoredWinnerAuditing);



// WEBPACK FOOTER //
// ./public/pages/ListWinners/SponsoredWinnerAuditing.jsx